const dateFormat1 = 'dd-MM-yyyy, HH:mm'; // 12-12-2019, 12:12
const dateFormat2 = 'dd LLL yyyy, HH:mm'; // 12 Des 2019 12:12
export { dateFormat1, dateFormat2 };
